<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">PASST</span></li>
        <li><span class="link-effect">Programación PASST</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Carga de Programación PASST</h3>
    </div>
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="model.idCompania" [disabled]="listaCompanias.length == 1"
                (selectionChange)="companiaChanged()">
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.sedes" multiple>
                <mat-option *ngFor="let sede of listaSedes; index as i;"
                  [value]='sede.idSede'>{{sede.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Año:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>
                Seleccione
              </mat-label>
              <mat-select matSelect [(ngModel)]="model.anio">
                <mat-option *ngFor="let item of listaAnios; index as i;" [value]='item'>{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </div>
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-new" (click)="registrarArchivo()" mat-raised-button><mat-icon>description</mat-icon>
              Cargar Información</a>
            <!-- [routerLink]="['/solicitudes-engie/registrar']" -->
            <!-- <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon> Exportar</a>                   -->
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" (click)="search()" mat-raised-button><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="listaCargas" class="table table-striped table-vcenter">
          <ng-container matColumnDef="anio">
            <th mat-header-cell *matHeaderCellDef>Año</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.anio }}</td>
          </ng-container>

          <ng-container matColumnDef="compania">
            <th mat-header-cell *matHeaderCellDef>Compañía</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
          </ng-container>

          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.nombreSede }}</td>
          </ng-container>

          <ng-container matColumnDef="archivo">
            <th mat-header-cell *matHeaderCellDef>Archivo</th>
            <td mat-cell *matCellDef="let element">{{ element.nombreArchivo }}</td>
          </ng-container>

          <ng-container matColumnDef="fechaCreacion">
            <th mat-header-cell *matHeaderCellDef>Fecha Carga</th>
            <td mat-cell *matCellDef="let element">{{ element.fechaCreacion | date:'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
          </ng-container>
          <ng-container matColumnDef="detalle">
            <th mat-header-cell *matHeaderCellDef>Detalle</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.detalle }}</td>
          </ng-container>

          <!-- <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="centre"> 
                  <a mat-icon-button color="primary" aria-label="Editar" [routerLink]="['/sso/', 'registrar']">
                    
                    <mat-icon>search</mat-icon>
                  </a>
                </td>
              </ng-container> -->

          <tr mat-header-row *matHeaderRowDef="displayedColumnsAccidente"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsAccidente"></tr>

        </table>

        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>